import { c as _c } from "react/compiler-runtime";
// Топ-покупатели площадки: рейтинг по сумме трат (spend) либо по числу заказов
// (orders) за окно. РЕАЛЬНЫЙ эндпоинт GET /admin/buyers/top (гард page.users).
// Каждая строка проваливается в карточку пользователя.
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import type { TopBuyerMetric } from "@/api";
import { useTopBuyers } from "@/api/hooks/use-users";
import { Card } from "@osmix/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Segmented } from "@/components/segmented";
import { formatCurrency, formatNumber } from "@osmix/formatters";
const PERIOD_OPTIONS = ["all", "30", "90", "365"] as const;
type Period = (typeof PERIOD_OPTIONS)[number];
export function TopBuyersPage() {
  const $ = _c(93);
  const {
    t
  } = useTranslation();
  const [metric, setMetric] = useState("spend");
  const [period, setPeriod] = useState("all");
  const days = period === "all" ? undefined : Number(period);
  const query = useTopBuyers(metric, days);
  let t0;
  if ($[0] !== query.data?.items) {
    t0 = query.data?.items ?? [];
    $[0] = query.data?.items;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const items = t0;
  let t1;
  if ($[2] !== t) {
    t1 = t("topBuyers.title");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <h1 className="text-2xl font-semibold tracking-tight">{t1}</h1>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("topBuyers.description");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <p className="text-sm text-muted-foreground">{t3}</p>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <div>{t2}{t4}</div>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t) {
    t6 = t("topBuyers.metric.spend");
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = {
      value: "spend",
      label: t6
    };
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t) {
    t8 = t("topBuyers.metric.orders");
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t8) {
    t9 = {
      value: "orders",
      label: t8
    };
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t7 || $[22] !== t9) {
    t10 = [t7, t9];
    $[21] = t7;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== metric || $[25] !== t10) {
    t11 = <Segmented value={metric} options={t10} onChange={setMetric} />;
    $[24] = metric;
    $[25] = t10;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t) {
    t12 = PERIOD_OPTIONS.map(value => ({
      value,
      label: value === "all" ? t("topBuyers.period.all") : t("topBuyers.period.days", {
        count: Number(value)
      })
    }));
    $[27] = t;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== period || $[30] !== t12) {
    t13 = <Segmented value={period} options={t12} onChange={setPeriod} />;
    $[29] = period;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t11 || $[33] !== t13) {
    t14 = <div className="flex flex-wrap items-center gap-3">{t11}{t13}</div>;
    $[32] = t11;
    $[33] = t13;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== query.error) {
    t15 = query.error && <div className="rounded-md border border-destructive/40 p-4 text-destructive">{query.error.message}</div>;
    $[35] = query.error;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <TableHead className="w-10 text-right">#</TableHead>;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t) {
    t17 = t("topBuyers.col.buyer");
    $[38] = t;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t17) {
    t18 = <TableHead>{t17}</TableHead>;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t) {
    t19 = t("topBuyers.col.contacts");
    $[42] = t;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== t19) {
    t20 = <TableHead>{t19}</TableHead>;
    $[44] = t19;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== t) {
    t21 = t("topBuyers.col.orders");
    $[46] = t;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== t21) {
    t22 = <TableHead className="text-right">{t21}</TableHead>;
    $[48] = t21;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== t) {
    t23 = t("topBuyers.col.gmv");
    $[50] = t;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  if ($[52] !== t23) {
    t24 = <TableHead className="text-right">{t23}</TableHead>;
    $[52] = t23;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  let t25;
  if ($[54] !== t) {
    t25 = t("topBuyers.col.avgCheck");
    $[54] = t;
    $[55] = t25;
  } else {
    t25 = $[55];
  }
  let t26;
  if ($[56] !== t25) {
    t26 = <TableHead className="text-right">{t25}</TableHead>;
    $[56] = t25;
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  let t27;
  if ($[58] !== t) {
    t27 = t("topBuyers.col.lastOrder");
    $[58] = t;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  let t28;
  if ($[60] !== t27) {
    t28 = <TableHead>{t27}</TableHead>;
    $[60] = t27;
    $[61] = t28;
  } else {
    t28 = $[61];
  }
  let t29;
  if ($[62] !== t18 || $[63] !== t20 || $[64] !== t22 || $[65] !== t24 || $[66] !== t26 || $[67] !== t28) {
    t29 = <TableHeader className="bg-muted/40"><TableRow>{t16}{t18}{t20}{t22}{t24}{t26}{t28}</TableRow></TableHeader>;
    $[62] = t18;
    $[63] = t20;
    $[64] = t22;
    $[65] = t24;
    $[66] = t26;
    $[67] = t28;
    $[68] = t29;
  } else {
    t29 = $[68];
  }
  let t30;
  if ($[69] !== query.isPending || $[70] !== t) {
    t30 = query.isPending && <TableRow><TableCell colSpan={7} className="h-24 text-center text-muted-foreground">{t("topBuyers.loading")}</TableCell></TableRow>;
    $[69] = query.isPending;
    $[70] = t;
    $[71] = t30;
  } else {
    t30 = $[71];
  }
  let t31;
  if ($[72] !== items.length || $[73] !== query.isPending || $[74] !== t) {
    t31 = !query.isPending && items.length === 0 && <TableRow><TableCell colSpan={7} className="h-24 text-center text-muted-foreground">{t("topBuyers.empty")}</TableCell></TableRow>;
    $[72] = items.length;
    $[73] = query.isPending;
    $[74] = t;
    $[75] = t31;
  } else {
    t31 = $[75];
  }
  let t32;
  if ($[76] !== items || $[77] !== t) {
    let t33;
    if ($[79] !== t) {
      t33 = (buyer, index) => <TableRow key={buyer.userId}><TableCell className="text-right text-lg font-semibold tabular-nums text-muted-foreground/50">{index + 1}</TableCell><TableCell className="font-medium"><Link to={`/users/${buyer.userId}`} className="hover:underline">{buyer.name?.trim() || buyer.phone || t("topBuyers.unnamed")}</Link></TableCell><TableCell className="text-muted-foreground"><span className="block truncate text-sm">{buyer.email && !buyer.email.endsWith("@buyer.osmix.local") ? buyer.email : "\u2014"}</span>{buyer.phone && <span className="block text-xs">{buyer.phone}</span>}</TableCell><TableCell className="text-right tabular-nums">{formatNumber(buyer.orders)}</TableCell><TableCell className="text-right tabular-nums">{formatCurrency(buyer.gmv, {
            maximumFractionDigits: 0
          })}</TableCell><TableCell className="text-right tabular-nums">{formatCurrency(buyer.avgCheck, {
            maximumFractionDigits: 0
          })}</TableCell><TableCell className="text-muted-foreground">{buyer.lastOrderAt ? new Date(buyer.lastOrderAt).toLocaleDateString("ru-RU") : "\u2014"}</TableCell></TableRow>;
      $[79] = t;
      $[80] = t33;
    } else {
      t33 = $[80];
    }
    t32 = items.map(t33);
    $[76] = items;
    $[77] = t;
    $[78] = t32;
  } else {
    t32 = $[78];
  }
  let t33;
  if ($[81] !== t30 || $[82] !== t31 || $[83] !== t32) {
    t33 = <TableBody>{t30}{t31}{t32}</TableBody>;
    $[81] = t30;
    $[82] = t31;
    $[83] = t32;
    $[84] = t33;
  } else {
    t33 = $[84];
  }
  let t34;
  if ($[85] !== t29 || $[86] !== t33) {
    t34 = <Card className="overflow-hidden py-0"><Table>{t29}{t33}</Table></Card>;
    $[85] = t29;
    $[86] = t33;
    $[87] = t34;
  } else {
    t34 = $[87];
  }
  let t35;
  if ($[88] !== t14 || $[89] !== t15 || $[90] !== t34 || $[91] !== t5) {
    t35 = <div className="grid gap-5">{t5}{t14}{t15}{t34}</div>;
    $[88] = t14;
    $[89] = t15;
    $[90] = t34;
    $[91] = t5;
    $[92] = t35;
  } else {
    t35 = $[92];
  }
  return t35;
}